<template>
  <div class="nav-container">
    <b-navbar toggleable="lg" type="dark"  class="nav_bar">
      <b-navbar-brand to="/">Coaching télétravail</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <!-- <b-navbar class="ml-auto" sticky> -->

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item to="/#presentation">
            Présentation
          </b-nav-item>
          <!-- <b-nav-item to="/#reviews">
				Témoignages
				</b-nav-item> -->
          <b-nav-item to="/formation">
            Formation & Coaching
          </b-nav-item>
          <b-nav-item to="/#contact">
            Contact
          </b-nav-item>
          <b-nav-item to="/#whoami">
            Qui suis-je ?
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
      <!-- </b-navbar> -->

      <!-- <router-link to="/about">
        <b-nav-item>Lidednk</b-nav-item>
      </router-link> -->
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: "Nav",
  methods: {},
};
</script>

<style></style>
